import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { ApiServiceContext } from '../../utils/shared.module'
import { end_points } from '../../services/core.index'
import * as yup from 'yup'
import TitleTypeSettings from '../../pages/feature/settings/systemDefinitions/titleTypeSetting'

const titleTypeFormSchema = yup.object().shape({
  titletypeName: yup.string().required('Title name is required'),
  typedescription: yup.string().required('Description is required'),
})

export const TitletypeContext = createContext({
  titleTypeFormSchema: titleTypeFormSchema,
  errorMessage: '',
  loading: false,
  listData: [],
  titleTypeList: async (search?: any) => {},
  setsearchTerm: (value: any) => {},
  childRef: {
    current: {
      handleLimitChange: (d: any) => {},
      pg_state: {
        first: 0,
        rows: 10,
        page: 0,
        totalRecords: 0,
      },
    },
  },
})

const TitleTypeComponentController = (props: any) => {
  const { getData } = useContext(ApiServiceContext)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [listData, setListData] = useState<any>([])
  const [searchTerm, setsearchTerm] = useState<string | number | null>('')
  const childRef: any = useRef(null)

  const def_page: number = childRef?.current?.pg_state?.page ?? 1
  const def_limit: number = childRef?.current?.pg_state.rows ?? 10
  const titleTypeList = async (page = def_page, limit = def_limit) => {
    try {
      let endPoint = `${end_points.titletypelist.url}`
      endPoint += `?page=${page}`
      endPoint += `&limit=${limit}`
      if (searchTerm) endPoint += `&searchTerm=${searchTerm}`
      getData(endPoint).then((res: any) => {
        if (res.status === 200) {
          setListData([...res?.data?.data])
          childRef?.current?.pgdispatch({
            type: 'totalRecords',
            payload: res?.data?.total_records || 0,
          })
        }
      })
    } catch (error) {
      setErrorMessage('Unable to fetch')
    }
  }

  useEffect(() => {
    titleTypeList()
  }, [])

  useEffect(() => {
    if (searchTerm) titleTypeList()
  }, [searchTerm])

  return (
    <TitletypeContext.Provider
      value={{
        titleTypeFormSchema,
        errorMessage,
        loading,
        listData: listData || [],
        titleTypeList,
        setsearchTerm,
        childRef,
      }}
    >
      {props.children}
    </TitletypeContext.Provider>
  )
}

const TitleTypeComponent = () => {
  return (
    <>
      <TitleTypeComponentController>
        <TitleTypeSettings />
      </TitleTypeComponentController>
    </>
  )
}
export default TitleTypeComponent
